import { createStore } from "vuex"
import axios from "axios"
import { Toast } from "vant"
// import md5 from "js-md5"
// import { Base64 } from "js-base64"

axios.defaults.withCredentials = true
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true
  })
}

let baseURL
if (process.env.NODE_ENV !== "production") {
  // baseURL = "/api/gkposter"
  baseURL = "http://localhost:8888";
} else {
  baseURL = "https://zsrbactivity.zsnews.cn"
}

export default createStore({
  state: {
    showStatement: false,
    statement: "",
    showPosterMerge: false,
    commentform: "", //表单内容
    cropImage: "", //裁剪后的照片
    poster: "", //合成的照片
    covers: [],
    orderNum: 0,
    jsBridgePackage: "",
    posterUrl: "",
    nickName: "",
    fullNickName: "",
    avatar: ""
  },
  mutations: {
    updateShowStatement(state, showStatement) {
      state.showStatement = showStatement;
    },
    updateShowPosterMerge(state, showPosterMerge) {
      state.showPosterMerge = showPosterMerge;
    },
    updateCropImage(state, cropImage) {
      state.cropImage = cropImage;
    },
    updateEnvData(state, envData) {
      state.covers = envData.covers;
      state.nickName = envData.nickname;
      state.fullNickName = envData.fullnickname;
      state.avatar = envData.avatar;
    },
    updateOrderNum(state, orderNum) {
      state.orderNum = orderNum;
    },
    updateCommentData(state, envData) {
      state.commentform = envData;
    },
    // updateUser(state, user) {
    //   state.user = user
    // const { aplus_queue } = window
    // aplus_queue.push({
    //   action: "aplus.setMetaInfo",
    //   arguments: ["_user_id", user.user_id]
    // })
    // },
    updateJsBridgePackage(state, jsBridgePackage) {
      state.jsBridgePackage = jsBridgePackage;
    }
  },
  actions: {
    getAppEnv({ commit }) {
      axios
        .get(baseURL + "/api/gkposter/index")
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              commit("updateEnvData", data.data);
            } else {
              Toast.success(data.msg);
            }
          } else {
            Toast.fail("网络错误，请重试");
          }
        })
        .catch(() => {
          Toast.fail("网络错误，请重试");
        });
    },
    getOrderNum({ commit }) {
      axios
        .get(baseURL + "/api/gkposter/order")
        .then((res) => {
          if (res.status === 200) {
            const data = res.data;
            if (data.code === 1) {
              commit("updateOrderNum", data.data);
            } else {
              Toast.success(data.msg);
            }
          } else {
            Toast.fail("网络错误，请重试");
          }
        })
        .catch(() => {
          Toast.fail("网络错误，请重试");
        });
    },
    getZsplusJsBrigde({ commit }) {
      return new Promise((resolve) => {
        axios
          .get(baseURL + "/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                commit("updateJsBridgePackage", data.data);
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByZsplus({ commit }, info) {
      return new Promise((resolve) => {
        axios
          .post(baseURL + "/api/common/zsplusauth", {
            sessionToken: info.sessionToken,
            head: info.head,
            nickName: info.nickName,
            phone: info.phone,
            gender: info.gender
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                commit("updateUser", data.data);
                sessionStorage.setItem("zsplusInfo", JSON.stringify(data.data));
                resolve();
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                tip(data.msg);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          });
      });
    },
    //要改为post
    loginByWx({ commit }, code) {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatauth", {
            params: { code }
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                if (data.data) {
                  // 存储微信授权用户信息
                  commit("updateUser", data.data);
                  sessionStorage.setItem("wxInfo", JSON.stringify(data.data));
                  resolve();
                } else {
                  tip(data.msg);
                }
              } else {
                tip(data.msg);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
            tip("网络错误，请重试");
          });
      });
    }
  },
  modules: {}
});
